import { Component, HostListener, OnInit } from '@angular/core';
import { Pauta } from '../../models/pauta.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PautaCombosResolver, PautaCombosResolverAgency, PautaResolverId } from '../../resolver/pauta.resolver';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { PautaService } from '../../services/pauta.service';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { ReuniaoCanDeactivate } from '../../reuniao-can-deactivate';

@Component({
  selector: 'app-pauta-edit',
  templateUrl: './pauta-edit.component.html',
  styleUrls: ['./pauta-edit.component.scss']
})
export class PautaEditComponent extends BaseFormComponent<Pauta> implements OnInit, ReuniaoCanDeactivate {

  type:string; //adicionar, clonar, editar
  id:number;
  filters: any;
  maxLines:number = 3;

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: PautaService,
    public pautaCombosResolver: PautaCombosResolver,
    public pautaCombosResolverAgency: PautaCombosResolverAgency,
    public pautaResolverId: PautaResolverId,
    private navigation: NavigationService,
    private router: Router
  ) { 
    super(activatedRoute);
  }

  canDeactivate(): boolean {
    return !this.form.dirty;
  }
  
  ngOnInit() {
    this.loading();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.type = params.get('type');
      this.id = +params.get('id');
    });
    this.actionLabel = this.type;
    this.initForm();
    this.start();
  }
  
  start(){
    this.pautaCombosResolver.resolve(this.id == 0? null:this.id).subscribe({
      next: (filters) => {
        this.filters = filters;
        if(this.id && this.id != 0 && (this.type == 'clonar' || this.type == 'editar')){
            this.pautaResolverId.getById( this.id ).subscribe({
              next: (data) => {
                this.entity = data;
                this.initForm();
                this.loaded();
              },
              error: (error) => {
                this.loaded();
                this.msgError(error?.error?.message);
                console.error(error);
              }
            })
        }
        else{
          this.loaded();
        }
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error?.message);
        console.error(error);
      }
    } );
  }
  searchAgency(){
    this.loading();
    var accord_main_id = this.getFormArray('accord_main_id').value;
    this.pautaCombosResolverAgency.resolve(accord_main_id).subscribe({
      next: (filters) => {
        this.filters = filters;
        this.loaded();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error.error);
      }
    })
  }

  initForm() {
    this.form = new FormGroup({
        id: new FormControl(null),
        agency_id: new FormControl(null, Validators.required),
        level_mon_id: new FormControl(null),
        dt_meet: new FormControl(null, Validators.required),
        hr_meeting_start: new FormControl(null),
        hr_meeting_end: new FormControl(null),
        description: new FormControl(null, Validators.required),
        accord_main_id: new FormControl(null, Validators.required),
        meeting_type_id: new FormControl(3),
        governance_level_id: new FormControl(null, Validators.required),
        axis_id: new FormControl(null),
        agency: this.createDataFormArray('agency',true),
        agency_fixed: this.createDataFormArray('agency_fixed', false),
    });
    if (this.entity) {
      this.form.patchValue(this.entity);
      if(this.type == 'clonar'){
        this.form.get('dt_meet').setValue(null);
      }
      else{
        this.form.get('dt_meet').setValue(this.formatDate(this.entity['dt_meet']));
      }
    }
    if(this.type == 'clonar'){
      this.form.markAsDirty();
    }
  }

  formatDate(dateString: string, reverse:boolean=false): string {
    try{
      if(reverse){
        const [day, month, year] = dateString.split('/');
        return `${year}-${month}-${day}`;
      }
      else{
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
      }
    }catch{
      return null;
    }

  }

  getAgencyLabel() {
    const selectedAgencyId = this.form.controls.agency_id.value;
    return this.filters?.agency_select?.find(a => a.id === selectedAgencyId)?.label || '';
  }

  createDataFormArray(field:string, required:boolean){
    if (!this.entity) {
      return new FormArray([new FormControl(null, required? Validators.required : null)]);
    }
    return new FormArray(this.entity[field].map(id => new FormControl(id)));
  }
  
  getFormArray(field:string): FormArray {
    return this.form.get(field) as FormArray;
  }

  addItem(field:string){
    this.getFormArray(field).push(new FormControl(null));
  }
  removeItem(field:string, index:number){
    this.getFormArray(field).removeAt(index);
  }

  getDataCreate() {
    var agency = [];
    var agency_fixed = [];

    this.form.value.agency.forEach(a => {
      if(a) {
        agency.push(a);
      }
    });
    this.form.value.agency = agency;

    this.form.value.agency_fixed.forEach(aF => {
      if(aF) {
        agency_fixed.push(aF);
      }
    });
    this.form.value.agency_fixed = agency_fixed;

    return Object.assign({}, this.form.value);
  }

  checkHour(){
    var data = this.getDataCreate();

    if(data['hr_meeting_start'] && data['hr_meeting_end'] && data['hr_meeting_start'] > data['hr_meeting_end']){
      this.form.controls['hr_meeting_end'].setErrors({'hr_meeting_end': 'A data final não pode ser maior que a data de início', });
    }
  }

  salvar(msg = "Deseja salvar as alterações?"): void {
    this.checkHour();
    if (this.form.valid) {
      this.alertConfirmation(null,msg).subscribe((confirmed) => {
        if (confirmed) {
            this.loading();
            var newData = this.getDataCreate();
            if(this.type == 'editar'){
              this.myService.update(newData,newData['id']).subscribe({
                next: (res) => {
                  this.form.markAsPristine();
                  this.msgSuccess('Pauta alterada com sucesso!');
                  this.loaded();
                },
                error: (error) => {
                  this.msgError(error.error.message);
                  this.loaded();
                },
              });
            } 
            else {
              if(this.type == 'clonar'){
                newData['clone_id'] = newData['id'];
              }
              this.myService.create(newData).subscribe({
                next: (res) => {
                  this.form.markAsPristine();
                  this.form.patchValue({'id': res});
                  this.confirmation("Reunião criada com sucesso!").subscribe(() => {
                    this.router.navigate(['../../../editar/' + res + '/pauta'], { relativeTo: this.activatedRoute });
                  })
                  this.loaded();
                },
                error: (error) => {
                  this.msgError(error.error.message);
                  this.loaded();
                },
              });
            }
          
        }
      });
    }
    else {
      this.markAsDirty();
      var form = this.form.get('agency') as FormArray;
      form.controls[0].markAsDirty();
    }
  }
  voltar() {
    this.navigation.back([`reuniao/reunioes`]);
    
  }

   limitLines(e) {
    const textarea = e.target;
    const lines = textarea.value.split('\n');
    if (lines.length > this.maxLines) {
      var newText = lines.slice(0, this.maxLines).join('\n');
      textarea.value = newText;
    }
  }

  onKeydownEnter(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    if (target.tagName === 'TEXTAREA') {
      return;
    }
    event.preventDefault();
  }
  
  
  dirtyListItem(field): boolean {
    var formItem = this.form.get(field) as FormArray;
    if(formItem.invalid && formItem.dirty){
      return true
    }
  }
  //detecta o ctrl+s, evita que o navegador faça o evento padrão e chama a função de salvar
  @HostListener('document:keydown.control.s', ['$event'])
  onCtrlS(event: KeyboardEvent): void {
    event.preventDefault(); 
    this.salvar();
  }
  //detecta se o formulário está manipulado e se  pessoa está atualizando a página ou saindo dela.
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: BeforeUnloadEvent): void {
    if (this.form.dirty) {
      event.preventDefault();
    }
  }

}
